import React, { useEffect, useState } from "react";
import { connect } from 'react-redux'
import Datacenter from "./components/datacenter/Datacenter";
import Hardware from "./components/hardware/Hardware";
import Image from "./components/image/Image";
import styles from './CloudInstance.module.scss'
import Card from "../../../../components/card/Card";

import { CUSTOM_SERVERS_COUNT_KEY } from "../../../../settings/content/deploymentStacker";

function CloudInstance({
                           instanceData, currentCloud, currentApp,
                           bodyServer,
                           custom
                       }) {

    const [status, setStatus] = useState('loading');

    const {regionsStatus, serversStatus, imagesStatus} = instanceData;
    const {regionsFetch, serversFetch, imagesFetch} = currentCloud?.config || {};

    useEffect(() => {
        if (!!currentCloud) {
            switch (true) {
                case (
                    (!!regionsFetch && regionsStatus === 'success' || !regionsFetch)
                    && (!!serversFetch && serversStatus === 'success' || !serversFetch)
                    && (!!imagesFetch && imagesStatus === 'success' || !imagesFetch)
                ):
                    setStatus('success');
                    break;
                case (
                    regionsStatus === 'error'
                    || serversStatus === 'error'
                    || imagesStatus === 'error'
                    || !currentCloud.config
                ):
                    setStatus('error');
                    break;
                default:
                    break;
            }
        }

    }, [regionsStatus, serversStatus, imagesStatus, currentCloud])


    let title = 'Instance';
    let messages = [];

    const pushMessage = message => messages.push({
        message: message, type: 'info', container: 'instance', target: 'instance',
    })

    if (status === 'error') {
        messages.push({ // do not use pushMessage, it creates excessive message in container header
            message: 'An error happened on our side',
            type: 'error',
            container: 'instance',
        });
    } else {

        const nodeNumbers = currentApp?.nodes?.map(node => node['node_number']) || [];
        const maxNode = custom
            ? bodyServer[CUSTOM_SERVERS_COUNT_KEY]
            : !!nodeNumbers?.length ? Math.max(...nodeNumbers) : 1;

        const {servers} = instanceData;
        const {server} = bodyServer;
        const selectedServer = !!servers && !!server ? servers.find(s => s['id'] === server) : null;

        if (!!server && (!!selectedServer?.prices?.hour || !!selectedServer?.prices?.month)) {

            const {prices} = selectedServer;
            let price = null;
            let period = null;

            if (!!prices.hour) {
                price = prices.hour;
                period = 'hour';
            }
            if (!!prices.month) {
                price = prices.month;
                period = 'month';
            }

            if (!!price && !isNaN(parseFloat(price)) && !!period) {
                price = Math.round(price * 100) / 100;
                if (!!maxNode && !isNaN(maxNode) && maxNode > 1) {
                    title = `Instances (x${maxNode})`;
                    pushMessage(`x${maxNode} ~ $${price}/${period} | ~ $${Math.round(price * maxNode * 100) / 100}/${period}`);
                } else {
                    pushMessage(`~ $${price}/${period}`);
                }
            }
        } else {
            pushMessage('Visit cloud page for prices');
        }
    }

    const renderContent = () => (
        status === 'error'
            ? <div className={styles.instance}>
                <div className={styles.error}>
                    <i
                        className={`fas fa-exclamation-triangle ${styles.error__icon}`}
                        aria-hidden="true"
                    />
                    <div className={styles.error__message}>
                        <p>The cloud provider is under maintenance.</p>
                        <p>
                            Please try again later or <a onClick={() => Tawk_API.toggle({start: ''})}>contact
                            support</a> if you see this.
                        </p>
                    </div>
                </div>
            </div>
            :
            <div className={styles.instance}>
                <div className={styles.instance__region}><Datacenter/></div>
                <div className={styles.instance__server}><Hardware custom={custom}/></div>
                <div className={styles.instance__image}><Image/></div>
            </div>
            // custom
            //     ?
            //     <>
            //         <div className={styles.instance__region}><Datacenter custom={custom}/></div>
            //         <div className={styles.instance__server}><Hardware custom={custom}/></div>
            //         <div className={styles.instance__image}><Image custom={custom}/></div>
            //     </>
            //     :
            //     <div className={styles.instance}>
            //         <div className={styles.instance__region}><Datacenter custom={custom}/></div>
            //         <div className={styles.instance__server}><Hardware custom={custom}/></div>
            //         <div className={styles.instance__image}><Image custom={custom}/></div>
            //     </div>
    );

    // if (custom) return renderContent();

    return (
        <Card
            style={{marginBottom: !custom ? '10px' : undefined}}
            title={title}
            messages={messages}
            id='instance'
            showMessages
        >
            {renderContent()}
        </Card>
    );
}

let mapStateToProps = state => ({
    currentApp: state.deployment.currentApp,
    instanceData: state.deployment.instanceData,
    currentCloud: state.deployment.currentCloud,
    bodyServer: state.deployment.bodyServer,
    bodyBuilder: state.deployment.bodyBuilder,
});

export default connect(mapStateToProps)(CloudInstance)